import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link, NavLink } from 'react-router-dom';
import App from './app.js';
import QuiverList from './pages/QuiverList';
import QuiverDetail from './pages/QuiverDetail';
import { AuthProvider, useAuth } from './lib/auth';

export default function Root() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NavBar />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/quiver" element={<QuiverList />} />
          <Route path="/quiver/:id" element={<QuiverDetail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

function NavBar() {
  const { user, signIn, signOut } = useAuth();
  const [name, setName] = useState('');

  const handleSignIn = (e) => {
    e.preventDefault();
    if (name.trim().length >= 2) {
      signIn(name);
      setName('');
    }
  };

  const linkStyle = ({ isActive }) => ({
    ...navStyles.link,
    ...(isActive ? navStyles.linkActive : null),
  });

  return (
    <nav style={navStyles.nav}>
      <div style={navStyles.inner}>
        <Link to="/" style={navStyles.brand}>
          <SmallMountain />
          <span>I-70</span>
        </Link>
        <div style={navStyles.links}>
          <NavLink to="/" end style={linkStyle}>Traffic</NavLink>
          <NavLink to="/quiver" style={linkStyle}>Quiver</NavLink>
        </div>
        <div style={navStyles.auth}>
          {user ? (
            <>
              <span style={navStyles.greeting}>Hi, <strong>{user.name}</strong></span>
              <button onClick={signOut} style={navStyles.signOut}>Sign out</button>
            </>
          ) : (
            <form onSubmit={handleSignIn} style={navStyles.signInForm}>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                maxLength={40}
                style={navStyles.signInInput}
              />
              <button type="submit" style={navStyles.signInButton}>Sign in</button>
            </form>
          )}
        </div>
      </div>
    </nav>
  );
}

function NotFound() {
  return (
    <div style={{ maxWidth: 600, margin: '80px auto', padding: 20, textAlign: 'center', fontFamily: 'Inter, system-ui, sans-serif' }}>
      <h1 style={{ fontSize: '2rem', color: '#1E293B', marginBottom: 8 }}>Page not found</h1>
      <p style={{ color: '#64748B', marginBottom: 24 }}>That route doesn’t exist.</p>
      <Link to="/" style={{ color: '#7C3AED', fontWeight: 600, textDecoration: 'none' }}>← Back to traffic</Link>
    </div>
  );
}

const SmallMountain = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m8 3 4 8 5-5 5 15H2L8 3z" />
  </svg>
);

const navStyles = {
  nav: {
    background: 'white',
    borderBottom: '1px solid #E2E8F0',
    fontFamily: 'Inter, system-ui, sans-serif',
  },
  inner: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '14px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: 24,
    flexWrap: 'wrap',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: '#1E293B',
    fontWeight: 800,
    fontSize: '1.05rem',
    textDecoration: 'none',
    letterSpacing: '-0.01em',
  },
  links: { display: 'flex', gap: 8 },
  link: {
    padding: '8px 14px',
    borderRadius: 10,
    color: '#64748B',
    fontWeight: 600,
    fontSize: '0.92rem',
    textDecoration: 'none',
  },
  linkActive: {
    background: '#EEF2FF',
    color: '#7C3AED',
  },
  auth: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  greeting: { color: '#64748B', fontSize: '0.9rem' },
  signOut: {
    background: 'transparent',
    border: '1px solid #E2E8F0',
    borderRadius: 10,
    padding: '6px 12px',
    cursor: 'pointer',
    color: '#64748B',
    fontWeight: 600,
    fontSize: '0.85rem',
    fontFamily: 'inherit',
  },
  signInForm: { display: 'flex', gap: 8 },
  signInInput: {
    padding: '8px 12px',
    borderRadius: 10,
    border: '1px solid #E2E8F0',
    fontSize: '0.9rem',
    color: '#1E293B',
    fontFamily: 'inherit',
    outline: 'none',
    width: 140,
  },
  signInButton: {
    background: '#7C3AED',
    color: 'white',
    border: 'none',
    borderRadius: 10,
    padding: '8px 14px',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '0.85rem',
    fontFamily: 'inherit',
  },
};
